/**
 * 部门模块 - 枚举定义
 * 
 * @module types/department/enums
 * @description 部门管理模块的枚举类型定义
 * 
 * 对应后端文件:
 * - backend/app/Models/Department.php (常量定义)
 * 
 * 注意事项:
 * - 枚举值必须与后端完全一致（包括大小写）
 * - 所有枚举值必须添加中文注释
 * 
 * @last-updated 2025-10-18
 */

/**
 * 部门状态枚举
 * 
 * 对应后端: Department::STATUS_*
 */
export enum DepartmentStatus {
  /** 启用 */
  ENABLED = 1,
  /** 禁用 */
  DISABLED = 0,
}

